var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.006 0H.994A.994.994 0 0 0 0 .994v16.013c0 .548.445.993.994.993h8.621v-6.97H7.269V8.313h2.346V6.31c0-2.325 1.42-3.591 3.494-3.591.994 0 1.848.074 2.097.107v2.43h-1.439c-1.128 0-1.346.537-1.346 1.323v1.735h2.69l-.35 2.716h-2.34V18h4.587a.993.993 0 0 0 .992-.994V.994A.994.994 0 0 0 17.006 0Z",
    fillOpacity: 0.4
  })));
};
export default SvgFacebook;